export const SET_PROFILE_DATA = "SET_PROFILE_DATA";

//organisation
export const SET_ORGANISATION_DATA = "SET_ORGANISATION_DATA";
export const SET_ORGANISATION_LOGO = "SET_ORGANISATION_LOGO";
export const LOAD_INDUSTRY_LIST = "LOAD_INDUSTRY_LIST";
export const LOAD_ORG_DISTRIBUTOR_LIST = "LOAD_ORG_DISTRIBUTOR_LIST";
export const LOAD_ORG_DATA = "LOAD_ORG_DATA";
export const LOAD_ORG_PARENT_COMPANY_LIST = "LOAD_ORG_PARENT_COMPANY_LIST";
export const LOAD_ORG_LANGUAGE_LIST = "LOAD_ORG_LANGUAGE_LIST";
export const LOAD_ORG_COUNTRY_LIST = "LOAD_ORG_COUNTRY_LIST";
export const LOAD_ORGANISATION_OPTIONS = "LOAD_ORGANISATION_OPTIONS";
//organisation

//team_profile
export const SET_TEAM_PROFILE_DATA = "SET_TEAM_PROFILE_DATA";

//organisation activity
export const SET_ACTIVITY_DATA = "SET_ACTIVITY_DATA";
